import React from 'react';
import Button from '../ui/button';
import SectionBackground from '../sections/section-background';
import Breadcrumb from '../ui/breadcrumb';

interface HeroTemplateCandidatProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  imageUrl: string;
  cta1?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  cta2?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  page: string;
  section?: string;
  breadcrumbs?: {
    name: string;
    href: string;
  }[];
}

export default function HeroTemplateCandidat({
  title,
  description,
  imageUrl,
  cta1,
  cta2,
  page,
  section = 'hero',
  breadcrumbs,
}: HeroTemplateCandidatProps) {
  return (
    <SectionBackground
      page={page}
      section={section}
  className="relative overflow-hidden bg-gradient-to-br from-[#fff1f2] via-[#fef9c3] to-[#e0f2ff]"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0 flex justify-end items-center pointer-events-none select-none">
        <img
          src={imageUrl}
          alt="Hero background"
          className="h-full object-contain max-h-[800px] md:pr-[5vw] opacity-20 md:opacity-100"
        />
      </div>

      {/* Content */}
      <section className="min-h-[85vh] flex items-center relative z-10">
        <div className="w-full px-[5vw] xl:px-[100px] max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-12">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-title font-extrabold leading-tight text-transparent bg-clip-text bg-gradient-primary">
              {title}
            </h1>

            {breadcrumbs && (
              <div className="my-4">
                <Breadcrumb items={breadcrumbs} />
              </div>
            )}

            <div className="mt-6 mb-8">
              {description}
            </div>

           <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
  <Button
    variant="gradient"
    size="lg"
    href={cta1.href}
    onClick={cta1.onClick}
  >
    {cta1.label}
  </Button>

  <Button
    variant={cta2.variant || "secondary"}
    size="lg"
    href={cta2.href}
    onClick={cta2.onClick}
className="flex items-center justify-center"  >
    {cta2.label}
  </Button>
</div>
          </div>
        </div>
      </section>
    </SectionBackground>
  );
}
